import { ReactNode } from "react";
import { BasePageRoot } from "./BasePage.styles";
import clsx from "clsx";

export interface BasePageProps {
    children?: ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

function BasePage({ className, ...rest }: BasePageProps) {
    return <BasePageRoot className={clsx("base-page", className)} {...rest} />;
}

export default BasePage;
